module.exports = __webpack_public_path__ + "img/waterpurifier27.fd06a484.jpg";